import classNames from 'classnames';

interface TabRequiredProps {
  name: string;
  current: boolean;
  cyTag: string;
}

interface Tab extends TabRequiredProps {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

interface TabProps {
  handleTabChange: (index: number) => void;
  activeTab: number;
  tabs: Tab[];
}
export const Tabs = ({ handleTabChange, activeTab, tabs }: TabProps) => {
  return (
    <div className="pb-4">
      <div className="sm:block">
        <nav aria-label="Tabs" className="flex border-b border-grey-800 overflow-x-auto scrollbar-none">
          {tabs.map((tab, index) => (
            <button
              type="button"
              data-cy={tab.cyTag}
              key={tab.name}
              aria-current={tab.current ? 'page' : undefined}
              className={classNames(
                index === activeTab
                  ? 'text-primary-50 border-b-2 border-primary-50 bg-white'
                  : 'text-grey-400 border-b-2 border-transparent hover:text-grey-100 hover:border-grey-600',
                'body-text px-3 sm:px-5 py-3 cursor-pointer transition-colors whitespace-nowrap',
                'lg:min-w-[140px] text-center -mb-px shrink-0'
              )}
              onClick={() => {
                handleTabChange(index);
              }}
            >
              <span>{tab.name}</span>
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};
